'use client';

import TitleDetails from './TitleDetails';

export default function ClientTitleDetailsWrapper({ docid }: { docid: string }) {
  return <TitleDetails docid={docid} />;
}
